import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import SideNav from "components/layout-components/SideNav";
import TopNav from "components/layout-components/TopNav";
import Loading from "components/shared-components/Loading";
import MobileNav from "components/layout-components/MobileNav";
import HeaderNav from "components/layout-components/HeaderNav";
import PageHeader from "components/layout-components/PageHeader";
import Footer from "components/layout-components/Footer";
import AppViews from "views/app-views";
import { Layout, Grid, Alert, Button, Modal, notification } from "antd";
import { useAuth } from "context/Auth";
import getVideo from "configs/NavigationVideos";
import HelpVideo from "./HelpVideo";
import { getAccountSection } from "views/shared/account/sections";
import { navigationConfig } from "configs/NavigationConfig";
import { SIDE_NAV_WIDTH, SIDE_NAV_COLLAPSED_WIDTH, NAV_TYPE_TOP, DIR_RTL, DIR_LTR } from "constants/ThemeConstant";
import utils from "utils";
import { useThemeSwitcher } from "react-css-theme-switcher";
import { withAuth } from "@salespark/api-client-v2";
import { createAPIClientAuth, createAPIClient } from "utils/helper";
import { useAuth0 } from "@auth0/auth0-react";
import { getAuth0LogoutOptions } from "components/util-components/Auth0/auth0Helpers";
import AccountStatus from "../../components/layout-components/AccountStatus";
import { ClockCircleOutlined } from "@ant-design/icons";
import "./inactive-account-modal.css";
const { Content } = Layout;
const { useBreakpoint } = Grid;

export const AppLayout = ({ navCollapsed, navType, location, direction }) => {
  const { auth } = useAuth();
  const { logout } = useAuth0();
  const [appNotice, setAppNotice] = useState([]);
  const [inactiveUser, setInactiveUser] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [memoizedPageVideo, setMemoizedPageVideo] = useState(undefined);
  const [incompletedCommentsNumber, setIncompletedCommentsNumber] = useState(0);

  const apiHandler = withAuth(createAPIClientAuth(auth.data));
  const publicApiHandler = withAuth(createAPIClient());

  const windowLocation = window.location.pathname;

  useEffect(() => {
    const _videoData = getVideo(windowLocation);
    setMemoizedPageVideo(_videoData);

    loadAppNotices(auth);
    if (auth?.data?.inactive_user === true) setInactiveUser(true);
    apiHandler.getOne("/comments/incompleted").then((res) => {
      if (!res.status) return;
      setIncompletedCommentsNumber(res.data?.count || 0);
    });
    return () => {};
  }, []);

  useEffect(() => {
    const _videoData = getVideo(windowLocation);
    setMemoizedPageVideo(_videoData);
  }, [windowLocation]);

  const reactivateAccount = async () => {
    setIsLoading(true);
    const res = await apiHandler.post("/producers/reactivate");
    if (!res.status) {
      notification.error({
        message: "Erro",
        description: "Ocorreu um erro ao reativar a conta",
      });
      setIsLoading(false);
      return;
    }

    window.location.href = "/dashboard";
  };

  const hasVideo = memoizedPageVideo !== undefined;

  const loadAppNotices = async () => {
    const res = await publicApiHandler.getMany("/actions/app-active-notices");
    if (!res.status) {
      return;
    }
    setAppNotice(res.data);
  };

  const currentRouteInfo = utils.getRouteInfo(navigationConfig(), location.pathname);
  const screens = utils.getBreakPoint(useBreakpoint());

  // Account routes are not part of navigationConfig, so the breadcrumb is driven
  // explicitly here (Conta > current section) instead of from the nav hierarchy.
  const isAccount = location.pathname.startsWith("/account/");
  const accountSection = isAccount ? getAccountSection(location.pathname) : null;

  // The manage-v2 course surface shares the single "Cursos" nav node, so the
  // breadcrumb would read "Cursos" on every tab. Show a clearer static label on
  // the course-management pages instead. Scoped to manage-v2 only (v1 is legacy
  // and kept untouched).
  const isCourseManageV2 = /\/courses\/manage-v2\/[^/]+\//.test(location.pathname);
  const pageHeaderTitle = isCourseManageV2 ? "Gestão do curso" : currentRouteInfo?.title;

  const isNavSide = navType !== NAV_TYPE_TOP;
  const isNavTop = navType === NAV_TYPE_TOP;

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  };

  // SET Mobile width definition
  const { width } = getWindowDimensions();
  const isMobile = !screens.includes("lg") || width < 1280;

  const getLayoutGutter = () => {
    if (isNavTop || isMobile) {
      return 0;
    }
    return navCollapsed ? SIDE_NAV_COLLAPSED_WIDTH : SIDE_NAV_WIDTH;
  };

  const { status } = useThemeSwitcher();

  if (status === "loading") {
    return <Loading cover="page" />;
  }

  const getLayoutDirectionGutter = () => {
    if (direction === DIR_LTR) {
      return { paddingLeft: getLayoutGutter() };
    }
    if (direction === DIR_RTL) {
      return { paddingRight: getLayoutGutter() };
    }
    return { paddingLeft: getLayoutGutter() };
  };
  //FIXME: WORKAROUND
  const noHeader = ["/buyers/view-details/", "/students/view-details/"]; //"/products/edit/"

  const headerDisplay = (d) => {
    //if (location.pathname.includes(noHeader)) return false;

    if (noHeader.some((substring) => location.pathname.includes(substring))) return false;
    return d;
  };

  const getBreadcrumbStyle = () => {
    if (isAccount || (hasVideo && headerDisplay(currentRouteInfo?.breadcrumb) === true)) {
      return {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "1rem",
      };
    }

    return { position: "absolute", right: "15px" };
  };

  const isAdminPage = location.pathname.includes("/admin/");
  return (
    <Layout>
      <HeaderNav isMobile={isMobile} />
      {isNavTop && !isMobile ? <TopNav routeInfo={currentRouteInfo} /> : null}
      <Layout className="app-container">
        {isNavSide && !isMobile ? <SideNav incompletedCommentsNumber={incompletedCommentsNumber} routeInfo={currentRouteInfo} /> : null}
        <Layout className="app-layout" style={getLayoutDirectionGutter()}>
          <div className={`app-content ${appNotice ? "app-content-notice" : ""}  ${isNavTop ? "layout-top-nav" : ""}`}>
            {/*
            TODO: No longer needed. 
             No information will be given to the producer in advance. 
             However, the company's details will be required before the funds can be raised.
              */}
            <AccountStatus authData={auth?.data} />
            {appNotice.length > 0 && (
              <div className="salespark-notice">
                {appNotice?.map((notice, index) => (
                  <Alert
                    key={index}
                    message={notice?.title || ""}
                    type={notice?.type || "info"}
                    banner
                    action={
                      notice?.showMore && (
                        <Link to={{ pathname: notice.showMore }} target="_blank">
                          <Button size="small" type="link">
                            Saber mais...
                          </Button>
                        </Link>
                      )
                    }
                  />
                ))}
              </div>
            )}
            <div className="pghd-row" style={getBreadcrumbStyle()}>
              <PageHeader
                display={isAccount ? true : headerDisplay(currentRouteInfo?.breadcrumb)}
                title={pageHeaderTitle}
                crumbs={isAccount ? [{ label: "Conta", to: "/account/plan" }] : undefined}
                plainTitle={isAccount ? accountSection?.label || "Conta" : undefined}
              />

              {hasVideo && !isAdminPage && <HelpVideo pageVideo={memoizedPageVideo} />}
            </div>
            <Content>
              <AppViews />
            </Content>
          </div>
          <Footer apiVersion={auth?.data?.apiVersion} />
        </Layout>
      </Layout>
      {isMobile && <MobileNav />}
      <Modal className="iac-modal" destroyOnClose={true} visible={inactiveUser} title={null} footer={null} closable={false} width={520}>
        <div className="iac-head">
          <span className="iac-tile">
            <ClockCircleOutlined />
          </span>
          <div>
            <div className="iac-eyebrow">Estado da conta</div>
            <div className="iac-title">Conta inativa por falta de atividade</div>
          </div>
        </div>

        <div className="iac-body">
          <p className="iac-text">
            A tua conta encontra-se inativa por falta de atividade. Verifica também em <strong>Dados do Negócio/Empresa</strong> se existe alguma
            pendência a resolver ou se a conta foi encerrada.
          </p>
          <p className="iac-ask">Queres reativar a tua conta?</p>
        </div>

        <div className="iac-foot">
          <Button className="sp-btn sp-btn-neutral" loading={isLoading} onClick={() => logout(getAuth0LogoutOptions())}>
            Não
          </Button>
          <Button className="sp-btn" loading={isLoading} onClick={() => reactivateAccount()}>
            Sim, quero reativar a minha conta
          </Button>
        </div>
      </Modal>
    </Layout>
  );
};

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, navType, locale } = theme;

  return { navCollapsed, navType, locale };
};

export default connect(mapStateToProps)(React.memo(AppLayout));
